'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_ui_extensions$() {
}
export { $c_Lpresto_ui_extensions$ as $c_Lpresto_ui_extensions$ };
$p = $c_Lpresto_ui_extensions$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ui_extensions$;
/** @constructor */
function $h_Lpresto_ui_extensions$() {
}
export { $h_Lpresto_ui_extensions$ as $h_Lpresto_ui_extensions$ };
$h_Lpresto_ui_extensions$.prototype = $p;
$p.sB = (function(el) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(el.hu(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.g.h("w-full")])));
});
$p.aS = (function(el) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(el.hu(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.g.h("x-input-bordered")])));
});
var $d_Lpresto_ui_extensions$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ui_extensions$, "presto.ui.extensions$", ({
  a4b: 1
}));
export { $d_Lpresto_ui_extensions$ as $d_Lpresto_ui_extensions$ };
var $n_Lpresto_ui_extensions$;
function $m_Lpresto_ui_extensions$() {
  if ((!$n_Lpresto_ui_extensions$)) {
    $n_Lpresto_ui_extensions$ = new $c_Lpresto_ui_extensions$();
  }
  return $n_Lpresto_ui_extensions$;
}
export { $m_Lpresto_ui_extensions$ as $m_Lpresto_ui_extensions$ };
//# sourceMappingURL=presto.ui.extensions$.js.map
